import { Deserializable } from '../../../../protocols/deserializable';
import { Address } from '../../../../users/dto/address';

export class EmployerSelfEnrolmentContact implements Deserializable {
  public id!: number;
  public firstName!: string;
  public lastName!: string;
  public jobTitle!: string | null;
  public email!: string;
  public phoneNumberCountryCode!: string;
  public phoneNumber!: string;
  public contactTopic!: string | null;
  public hasSigningAuthority!: boolean;
  public primaryContact!: boolean;
  public address!: Address | null;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (!!this.address) {
      this.address = Deserialize?.instanceOf(Address, this.address);
    }
  }
}
